import { Area, AreaChart, CartesianGrid, Tooltip, XAxis, YAxis } from 'recharts';
import { AutoSizer } from 'react-virtualized-auto-sizer';
import { capitalizeWords } from '@blisspointmedia/bpm-types/dist/MMMUtils';
import {
  CARTESIAN_GRID_STROKE,
  CARTESIAN_GRID_STROKE_WIDTH,
  TICK_STYLE
} from '@Components/Charts/ChartConstants';
import { useDynamicYAxisWidth } from '@Components/Charts/ChartUtils';
import '@Pages/GeoMMM/Results/Components/Spend.scss';
import { Brand50 } from '@src/utils/colors';
import { dateToMddyy } from '../../../../utils/date-utils';
import { DateGroupedTooltipContent } from './tooltip-utils';

interface SpendProps {
  data: any[];
  dateGrouping: string;
  syncId?: number;
  tooltipFormatter?: (value: any) => string;
  yAxisFormatter?: (value: any) => string;
}

export const Spend = ({
  data,
  dateGrouping,
  syncId,
  tooltipFormatter,
  yAxisFormatter
}: SpendProps) => {
  const { yAxisWidth, setChartRef } = useDynamicYAxisWidth({
    yAxisWidthModifier: x => x + 7,
    reCalcDependency: data
  });

  return (
    <div className='spend-chart-wrapper'>
      <div className='spend-chart'>
        <AutoSizer
          renderProp={({ width, height }) => (
            <AreaChart
              width={width}
              height={height}
              data={data}
              margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
              syncId={syncId}
              ref={setChartRef}
            >
              <XAxis dataKey='date' tick={TICK_STYLE} tickFormatter={val => dateToMddyy(val)} />
              <YAxis
                tick={TICK_STYLE}
                tickFormatter={yAxisFormatter}
                tickLine={false}
                axisLine={false}
                width={yAxisWidth}
              />
              <CartesianGrid
                stroke={CARTESIAN_GRID_STROKE}
                strokeWidth={CARTESIAN_GRID_STROKE_WIDTH}
                vertical={false}
              />
              <Area
                dataKey='spend'
                fill={Brand50}
                isAnimationActive={false}
                stroke={Brand50}
                type='monotone'
                fillOpacity={1}
              />
              <Tooltip
                content={
                  <DateGroupedTooltipContent
                    dateGrouping={dateGrouping}
                    getLabel={item => capitalizeWords(item.name ?? '')}
                    formatValue={value => (tooltipFormatter ? tooltipFormatter(value) : value)}
                  />
                }
                isAnimationActive={false}
              />
            </AreaChart>
          )}
        />
      </div>
      <div className='right-of-chart'>
        <div className='legend'>
          <div className='legend-item'>
            <div className='square' style={{ backgroundColor: Brand50 }} />
            <div>Spend</div>
          </div>
        </div>
      </div>
    </div>
  );
};
